import { Box } from "@mui/material";
import { DynamicFormBuilderContainer } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FieldFailureReportsGetAPI } from "../../services/apiCalls";
import { FieldFailureReportsKeys } from "../../services/entity";
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { ReactComponent as CloseIcon } from "../../../../assets/images/closeIcon.svg";
import { GeneralMobileView } from "./GeneralView";
import { PhysicalPhenamenaMobileView } from "./PhysicalPhenamena";
import { AdditionalInfoMobileView } from "./AdditionalInfo";
import { DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from "../../../../assets/customIcons";
import { EditIcon } from "../../assets/svg";
import { useNavigate } from "react-router-dom";
import { ChecklistView } from "./ChecklistView";
var FieldFailureReportDetailsMobileView = function (_ref) {
    var onClose = _ref.onClose, data = _ref.data;
    var navigate = useNavigate();
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "",
            label: "",
            value: "",
            columnSize: 12,
            display: "flex",
            spacing: 0,
            pl: 2,
            item: false,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: 'root',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: "DocumentName",
                            valueGetter: function (state) { return "Details -".concat(state.DocumentName); },
                            fontWeight: "strong",
                            fontSize: "xl",
                            columnSize: true
                        }, {
                            type: FormItemTypes.IconButton,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                color: "text.secondary",
                                height: "12px",
                                width: "12px"
                            }),
                            columnSize: 0,
                            onClick: function () {
                                onClose(false);
                            }
                        }]
                }, {
                    type: FormItemTypes.Chip,
                    name: "Status",
                    value: function (state) { return state.Status; },
                    columnSize: 12,
                    color: "info",
                    sx: {
                        borderRadius: 1
                    }
                }]
        }, {
            type: FormItemTypes.Divider,
            name: "",
            columnSize: 12
        }, {
            type: FormItemTypes.ContainerItem,
            name: "",
            sx: {
                pt: 0,
                pb: 10
            },
            columnSize: true,
            elements: [{
                    type: FormItemTypes.Tabs,
                    name: "Stepper",
                    label: "",
                    value: null,
                    tabs: [{
                            id: "0",
                            label: "General",
                            elements: GeneralMobileView
                        }, {
                            id: "1",
                            label: "Physical Phenamena",
                            elements: PhysicalPhenamenaMobileView
                        }, {
                            id: "2",
                            label: "Additional info",
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: "table",
                                    columnSize: 12,
                                    spacing: 0,
                                    elements: AdditionalInfoMobileView
                                }]
                        }, {
                            id: "3",
                            label: "Checklist",
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: "table",
                                    columnSize: 12,
                                    spacing: 0,
                                    elements: ChecklistView
                                }]
                        }],
                    valueExpr: "id",
                    displayExpr: "label",
                    columnSize: 12,
                    variant: "scrollable"
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'Footer',
            columnSize: 12,
            justifyContent: 'end',
            sx: {
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                padding: 2,
                backgroundColor: 'background.paper',
                borderTop: '1px solid',
                borderColor: 'divider',
                zIndex: 1
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: true,
                    item: false,
                    justifyContent: "end",
                    spacing: 1,
                    alignItems: "center",
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: "secondary"
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: "secondary"
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: "secondary"
                        }, (data === null || data === void 0 ? void 0 : data.Status) === 'Open' ? {
                            type: FormItemTypes.Button,
                            name: '',
                            columnSize: 0,
                            startIcon: /*#__PURE__*/ React.createElement(EditIcon, null),
                            variant: "outlined",
                            color: 'primary',
                            onClick: function () {
                                if (data !== null && data !== void 0 && data.id) {
                                    navigate("/fieldFailureReports/".concat(data === null || data === void 0 ? void 0 : data.id));
                                    onClose();
                                }
                            }
                        } : null]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        p: 2,
        sx: {
            paddingTop: {
                md: "60px",
                lg: "60px"
            }
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        gridProps: {
            spacing: 0,
            gap: "20px"
        },
        formData: formData,
        getFormAPI: FieldFailureReportsGetAPI,
        getKey: FieldFailureReportsKeys.create,
        getRequest: {
            id: data === null || data === void 0 ? void 0 : data.id
        }
    })));
};
export default FieldFailureReportDetailsMobileView;
